import { rem, tint } from 'polished'
import styled from 'styled-components'

import { ProgressStyled } from '@ui/elements/Progress/styles/ProgressStyled'

interface IUploadProgressStyledProps {}

export const UploadProgressStyled = styled.div<IUploadProgressStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: absolute;

  bottom: 0;
  left: 0;
  right: 0;

  ${ProgressStyled} {
    .root {
      height: ${rem(3)};
      background: ${(props) => tint(0.5, props.theme.colors.yellow)};

      .bar {
        background: ${(props) => props.theme.colors.yellow};
      }
    }
  }
`
